<template>
  <div
    class="space-block"
    :class="getClassName"
  />
</template>

<script lang="ts" setup>
import type { IBlockDefaultProps } from '#sitis/internal/models/common';

const props = defineProps<IBlockDefaultProps>();
const getClassName = computed(() => {
  const _list: string[] = [];
  if (props.values.type === 10) {
    _list.push('--small');
  }
  if (props.values.type === 50) {
    _list.push('--medium');
  }
  if (props.values.type === 100) {
    _list.push('--big');
  }
  return _list.join(' ');
});
</script>

<style lang="scss">
.space-block {
	&.--small {
		margin-top: 30px;
	}

	&.--medium {
		margin-top: 44px;
	}

	&.--big {
		margin-top: 64px;
	}
}

@media (max-width: 1023px) {
	.space-block.--medium {
		margin-top: 24px;
	}
	.space-block.--big {
		margin-top: 40px;
	}
}
</style>
